import React, { useState, useEffect } from "react";

const withForceRerender =
  (WrappedComponent) =>
  ({ ...props }) => {
    const [rerenderValue, setRerenderValue] = useState(0);

    // A trick to make Textfit works accurate
    const forceRerender = () => {
      setRerenderValue((oldValue) => oldValue + 1);
    };

    useEffect(() => {
      setTimeout(forceRerender, 150);
    }, []);

    return (
      <>
        {rerenderValue && (
          <div
            className="hidden"
            style={{
              position: "absolute",
              visibility: "hidden",
              width: 0,
              height: 0,
              overflow: "hidden",
            }}
            id={rerenderValue}
          />
        )}
        <WrappedComponent {...props} />
      </>
    );
  };

export default withForceRerender;
